import { createWebHistory, createRouter } from "vue-router";
import FormSection from "@/components/FormSection.vue";
import AcreditacionFinalizada from "@/components/AcreditacionFinalizada.vue";
import NotFoundSection from "@/components/NotFoundSection.vue";
import PrensaSection from "@/components/PrensaSection.vue";

const routes = [
  {
    path: "/",
    component: FormSection,
  },
  {
    path: "/prensa",
    component: PrensaSection,
  },
  {
    path: "/finalizado",
    name: "Finalizado",
    component: AcreditacionFinalizada,
  },
  {
    path: "/noExiste",
    component: NotFoundSection,
  },
  {
    path: "/:catchAll(.*)",
    component: NotFoundSection,
  },  
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes,
  scrollBehavior() {
    return { top: 0 }
  }
});

export default router;